<ion-grid class="info-panel step-2--perfect">
  <ion-card
    class="wrapper wrapper--preliminary info-panel__card info-panel__card--first"
  >
    <app-preliminary-difference
      [preliminaryDifferenceAgreement]="preliminaryDifferenceAgreement"
      [isReadonly]="isReadonly"
    ></app-preliminary-difference>
  </ion-card>

  @if (isHybridWorkLocation()) {
    <ion-row>
      <ion-col>
        <ion-list lines="none">
          <app-time-input
            [data]="presentialTimeInput"
            [timeInputClass]="presentialTimeInput.class"
            [initialValues]="presentialTimeInitialValues"
            (changeTime)="onPresentialTimeChange($event)"
            class="time-input time-input--first"
            [isReadOnly]="isReadonly"
          ></app-time-input>
        </ion-list>
      </ion-col>
    </ion-row>
  }

  <app-effective-working-time
    [effectiveWorkingTime]="effectiveWorkingTime"
    [isReadonly]="isReadonly"
    [isDisabled]="isHybridWorkLocation() && presentialTimeMinutes === 0"
    (confirmSend)="send()"
  ></app-effective-working-time>
</ion-grid>
